import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "quick-start"
    }}>{`Quick Start`}</h1>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`import Flexy from "react-flexy";

const Horizontally = () => {
  return (
    <Flexy.Horizontal spaceAll="m">
      <h1>Usage</h1>
      <Content />
    </Flexy.Horizontal>
  );
};

const Vertically = () => {
  return (
    <Flexy.Vertical spaceBetween>
      <h1>Usage</h1>
      <Content />
    </Flexy.Vertical>
  );
};
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      